import React, { useEffect, useState } from "react";
import {
	InputAltitudeUnit,
	InputDistanceUnit,
	InputSpeedUnit,
	InputVolumeUnit,
} from "../../Helpers/Input/Input";
import trans from "../../../utils";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import { currencies } from "../../../utils/Currencies/Currencies";
import axios from "axios";
import usePermission from "../../../hooks/usePermission";

export default function AccountPereferences({ inf, setFormValidation }) {
	const [timezones, setTimeZone] = useState([]);
	const { edit } = usePermission("SETUPACCOUNT");

	useEffect(() => {
		if (
			inf.errors.attributes?.speedUnit ||
			inf.errors.attributes?.distanceUnit ||
			inf.errors.attributes?.volumeUnit ||
			inf.errors.attributes?.altitudeUnit
		) {
			setFormValidation(true);
		} else {
			setFormValidation(false);
		}
	}, [inf.errors, inf.values.password, setFormValidation]);
	const getTimeZones = async () => {
		await axios
			.get(`${process.env.REACT_APP_API_URL}/server/timezones`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("token")}`,
				},
			})
			.then((data) => {
				setTimeZone(
					data?.data?.map((i) => {
						return { label: i, value: i };
					})
				);
			})
			.catch((err) => console.log("Err", err));
	};
	useEffect(() => {
		getTimeZones();
	}, []);
	return (
		<div className="account-layout mb-3">
			<div>
				<div className="account-layout-head">{trans("Preferences")}</div>
				<p className="account-layout-title">
					{trans("Manage pereferences of your profile.")}
				</p>
				<div className="row">
					<div className="col-lg-6 col-sm-12">
						<InputSpeedUnit
							formstyle="form-input"
							id="attributes.speedUnit"
							name="attributes.speedUnit"
							onBlur={() => inf.setFieldTouched("attributes.speedUnit", true)}
							onChange={(value) =>
								inf.setFieldValue("attributes.speedUnit", value ? value : "")
							}
							touched={inf.touched.attributes?.speedUnit}
							errors={inf.errors.attributes?.speedUnit}
							value={inf.values.attributes.speedUnit || ""}
							disabled={!edit}
						/>
						<InputDistanceUnit
							formstyle="form-input"
							id="attributes.distanceUnit"
							name="attributes.distanceUnit"
							onBlur={() =>
								inf.setFieldTouched("attributes.distanceUnit", true)
							}
							onChange={(value) =>
								inf.setFieldValue("attributes.distanceUnit", value ? value : "")
							}
							touched={inf.touched.attributes?.distanceUnit}
							errors={inf.errors.attributes?.distanceUnit}
							value={inf.values.attributes.distanceUnit || ""}
							disabled={!edit}
						/>
					</div>
					<div className="col-lg-6 col-sm-12">
						<InputAltitudeUnit
							formstyle="form-input"
							id="attributes.altitudeUnit"
							name="attributes.altitudeUnit"
							onBlur={() =>
								inf.setFieldTouched("attributes.altitudeUnit", true)
							}
							onChange={(value) =>
								inf.setFieldValue("attributes.altitudeUnit", value ? value : "")
							}
							touched={inf.touched.attributes?.altitudeUnit}
							errors={inf.errors.attributes?.altitudeUnit}
							value={inf.values.attributes.altitudeUnit || ""}
							disabled={!edit}
						/>
						<InputVolumeUnit
							formstyle="form-input"
							id="attributes.volumeUnit"
							name="attributes.volumeUnit"
							onBlur={() => inf.setFieldTouched("attributes.volumeUnit", true)}
							onChange={(value) =>
								inf.setFieldValue("attributes.volumeUnit", value ? value : "")
							}
							touched={inf.touched.attributes?.volumeUnit}
							errors={inf.errors.attributes?.volumeUnit}
							value={inf.values.attributes.volumeUnit || ""}
							disabled={!edit}
						/>
					</div>
					<div className="col-lg-6 col-sm-12">
						<InputSelect
							label="currency"
							options={currencies}
							onBlur={() => inf.setFieldTouched("attributes.currency", true)}
							onChange={(value) =>
								inf.setFieldValue("attributes.currency", value ? value : "")
							}
							value={inf.values.attributes.currency || ""}
							disabled={!edit}
						/>
					</div>
					{/*<div className="col-lg-6 col-sm-12">
						<InputSelect
							label="timezone"
							options={timezones && timezones}
							onBlur={() => inf.setFieldTouched("attributes.timezone", true)}
							onChange={(value) =>
								inf.setFieldValue("attributes.timezone", value ? value : "")
							}
							value={inf.values.attributes.timezone || ""}
						/>
					</div>*/}
					<div className="col-lg-6 col-sm-12">
						{/* <InputSelect
							label="timezone"
							options={[
								{ label: trans("Egypt"), value: "EG_UTC+3" },
								{ label: trans("Saudi Arabia"), value: "SA_UTC+3" },
								{ label: trans("United Arab Emirates"), value: "AE_UTC+4" },
								{ label: trans("Qatar"), value: "QA_UTC+3" },
							]}
							onBlur={() => inf.setFieldTouched("attributes.timezone", true)}
							onChange={(value) =>
								inf.setFieldValue("attributes.timezone", value ? value : "")
							}
							value={inf.values.attributes.timezone || ""}
						/> */}
					</div>
				</div>
			</div>
		</div>
	);
}
